import { useAuthStore } from '@/store/auth.store'
import { authApi } from '@/services/api'
import { useNavigate } from 'react-router-dom'

export function useAuth() {
  const { user, token, isAuthenticated, setAuth, updateUser, logout: storeLogout } = useAuthStore()
  const navigate = useNavigate()

  const login = async (email: string, password: string, recaptchaToken?: string | null) => {
    const response = await authApi.login(email, password, recaptchaToken)
    if (response.success && response.data) {
      setAuth(response.data.user, response.data.token)
      return response.data.user
    }
    throw new Error(response.message || 'Login failed')
  }

  const register = async (data: any, recaptchaToken?: string | null) => {
    const response = await authApi.register(data, recaptchaToken)
    if (response.success && response.data) {
      setAuth(response.data.user, response.data.token)
      return response.data.user
    }
    throw new Error(response.message || 'Registration failed')
  }

  const logout = () => {
    storeLogout()
    navigate('/login')
  }

  const hasPermission = (allowedRoles: string[]) => {
    if (!user) return false
    return allowedRoles.includes(user.user_type)
  }

  const isAdmin = () => {
    return hasPermission(['admin', 'super_admin'])
  }

  const isSuperAdmin = () => {
    return hasPermission(['super_admin'])
  }

  const isProfessional = () => {
    return user?.user_type === 'professional'
  }

  const hasActiveSubscription = () => {
    if (!user) return false
    if (user.user_type !== 'professional') return true
    return user.subscription_status === 'active'
  }

  return {
    user,
    token,
    isAuthenticated,
    login,
    register,
    logout,
    updateUser,
    hasPermission,
    isAdmin,
    isSuperAdmin,
    isProfessional,
    hasActiveSubscription,
  }
}
